import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { OpenPosition } from 'frontend/types/open-positions';

interface OpenPositionsState {
  positions: OpenPosition[];
}

const openPositions: Module<OpenPositionsState, RootState> = {
  namespaced: true,
  state: {
    positions: [],
  },
  mutations: {
    setValue(state: OpenPositionsState, value: OpenPositionsState): void {
      state.positions = value.positions;
    },
  },
};

export default openPositions;
